import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/// Склейка классов с разрешением конфликтов Tailwind: у последнего слово.
/// Нужна там, где компонент задаёт дефолт, а вызывающий его переопределяет.
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
